import { render, staticRenderFns } from "./PageView.vue?vue&type=template&id=4d4efbea&scoped=true"
import script from "./PageView.vue?vue&type=script&lang=js"
export * from "./PageView.vue?vue&type=script&lang=js"
import style0 from "./PageView.vue?vue&type=style&index=0&id=4d4efbea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4efbea",
  null
  
)

export default component.exports